import {SpaceProto} from "../space-proto";
import {NavigationButtonPosition, NavigationSectionType} from "../../navigation/@const";
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section";
import navigation_hintButtonSectionView from "../../../../layout/navigation/components/hint/section-view";
import {UIType} from "../../../../layout/ui/@const";


export class SpaceSearch extends SpaceProto {

    constructor() {
        super(NavigationSectionType.SEARCH)

        this.title              = "Search"
        this.svgIcon            = "isvg-search"

        // // patch
        // if (gd.ui.type === UIType.ASANA) {
        //     this.defaultPosition = NavigationButtonPosition.STATIC
        //     this.positions = [NavigationButtonPosition.STATIC]
        // }

        switch (gd.ui.type) {

            case UIType.ASANA:
            case UIType.TEAMS:
                this.positions = []
                break

            default:
                this.defaultPosition    = NavigationButtonPosition.BOTTOM
                this.positions          = [NavigationButtonPosition.BOTTOM, NavigationButtonPosition.MORE]
                break

        }

    }

    get position() {
        // patch
        if (gd.ui.type === UIType.ASANA || gd.ui.type === UIType.TEAMS || gd.ui.type === UIType.TOP) {
            return NavigationButtonPosition.STATIC
        }

        return super.position
    }

    set position(position: NavigationButtonPosition) {
        super.position = position
    }

    onClick = () => {
        gd.modals.other.showMagicSearch()
    }

    // getDisplayOptions():Options {
    //
    //     return [
    //         OptionNavigationPanelBottom,
    //         OptionNavigationPanelMore
    //     ]
    //
    // }

    get navigationStructureConfig() {

        return {
            id              : NavigationSectionType.SEARCH,
            type            : NavigationSectionType.SEARCH,
            icon            : "i5-nav-search",
            hint            : "Search",
            keyboardShortcut: 'S',
            renderComponent : Navigation_ButtonGenericDeprecated,
            onClick         : this.onClick,
            position        : this.position,
            hintButtons     : navigation_hintButtonSectionView,
        }

    }



}
